if (!customElements.get('wd-installments')) {
class Installments extends HTMLElement {
    /** @type {HTMLSpanElement} */
    priceEL;
    /** @type {HTMLSpanElement} */
    installmentsEL;

    constructor() {
        super();
        this.priceEL = this.querySelector('.installments_price');
        this.installmentsEL = this.querySelector('.installments_count');
    }
    connectedCallback() {
        if (!window.paymentTiers)
            return console.warn('Installments: payment tiers not found');
        this.updateInstallments(Number(this.dataset.price));
        window.addEventListener('priceChange', this.handlePriceChange);
    }

    disconnectedCallback() {
        window.removeEventListener('priceChange', this.handlePriceChange);
    }

  setStructuredPrice(el, amountMajor) {
    if (!el) return;
    if (window.WDPriceFormat?.setElementHtml) {
      window.WDPriceFormat.setElementHtml(el, amountMajor, 'installment');
      return;
    }
    el.textContent = amountMajor.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

    /** @param {CustomEvent<{ totalPrice: number, totalCompare?: number }>} e */
    handlePriceChange = (e) => {
        const totalPrice = e.detail.totalPrice;
        this.updateInstallments(totalPrice);
    };

    updateInstallments(totalPrice) {
        /** @type {Array<{min_price: number, installments_count: number}>} */
        let paymentTiers = window.paymentTiers;
        const tier = paymentTiers.find(t => totalPrice >= Number(t.min_price));
        if (tier) {
            const decimals = Number(this.dataset.decimals) || 0;
            const zeroShift = 10 ** decimals;
            const monthlyPayment = (totalPrice / tier.installments_count * zeroShift) / zeroShift;
            this.setStructuredPrice(this.priceEL, monthlyPayment);
            this.installmentsEL.textContent = tier.installments_count.toLocaleString();
            this.toggleSkeleton(false);
        }
    }


    toggleSkeleton(show) {
        if (show) {
            this.priceEL.classList.add('skeleton');
            this.installmentsEL.classList.add('skeleton');
        } else {
            this.priceEL.classList.remove('skeleton');
            this.installmentsEL.classList.remove('skeleton');
        }
    }
}

customElements.define('wd-installments', Installments);
}
